import React from 'react';
import { RotatingLines } from 'react-loader-spinner'
const PreLoader = () => {
    return (
        <div className='w-full min-h-screen bg-[#283747]'>
            <div className='w-full min-h-screen flex justify-center items-center'>
                <div className='w-full'>
                    <div className='w-full flex justify-center'>
                        <RotatingLines
                            visible={true}
                            height="96"
                            width="96"
                            color="grey"
                            strokeWidth="2"
                            animationDuration="0.75"
                            ariaLabel="rotating-lines-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>
                    <div className='w-full flex justify-center'>
                        <div className='mt-5'>
                            <span className='text-white text-sm poppins-medium'>Loading</span>
                            <span className='text-white text-sm poppins-medium'> . . . </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PreLoader;
